import { RadioButtonGroupComponent } from './components/basic/radio-button-group/radio-button-group.component';
import { DecoratorDirective } from './directives/decorator.directive';

// Import this barrel via a relative path to avoid Angular NG3004.

export const RadioButtonGroup = [
  RadioButtonGroupComponent,
  DecoratorDirective
];
